import styled from "@emotion/styled";
import type { BaseTokenIconProps } from "@stepfinance/react";
import type { FC } from "react";
import { useState } from "react";

import selectionChevronSVG from "../../assets/selection-chevron.svg";
import type { TokenInfoDisplayProps } from "../AmountInput/TokenInfoDisplay";
import { TokenInfoDisplay } from "../AmountInput/TokenInfoDisplay";
import type { SwapTokenSelectModalProps } from "../Trade/SwapTokenSelectModal";
import { SwapTokenSelectModal } from "../Trade/SwapTokenSelectModal";

const SelectCurrencyWrapper = styled.div<{ disabled: boolean }>`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? "text" : "pointer")};
`;

const SelectionChevronImage = styled.img`
  margin-left: 6px;
`;

export type SwapTokenSelectorProps = TokenInfoDisplayProps &
  Pick<SwapTokenSelectModalProps, "dependentMint" | "onMintChange"> &
  Pick<BaseTokenIconProps, "mintAddress"> & {
    disabled?: boolean;
  };

export const SwapTokenSelector: FC<SwapTokenSelectorProps> = ({
  disabled = false,
  mintAddress,
  symbol,
  dependentMint,
  onMintChange,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isValidMintAddress = !Array.isArray(mintAddress);

  const handleCurrencyClick = () => {
    if (!disabled && onMintChange) {
      setIsModalOpen(true);
    }
  };

  return (
    <>
      <SelectCurrencyWrapper
        disabled={disabled || !onMintChange}
        onClick={isValidMintAddress ? handleCurrencyClick : undefined}
      >
        <TokenInfoDisplay mintAddress={mintAddress} symbol={symbol} />
        {!disabled && isValidMintAddress && onMintChange && (
          <SelectionChevronImage src={selectionChevronSVG} alt="Select Currency" width={20} height={20} />
        )}
      </SelectCurrencyWrapper>
      {!Array.isArray(mintAddress) && (
        <SwapTokenSelectModal
          mint={mintAddress}
          dependentMint={dependentMint}
          onMintChange={onMintChange}
          currencySelectionVisible={isModalOpen}
          setCurrencySelectionVisible={setIsModalOpen}
        />
      )}
    </>
  );
};
